import { apiGetSbtList } from '@/apis/sbt';
import Button from '@/components/button';
import { Card } from '@/components/card';
import { useEffect, useRef, useState } from 'react';
import ClaimModal from './claimModal';
import Typography from '@/components/typography';
// import BgImg from '@/assets/bg_cover.svg';
import gitcoinbg from '@/assets/donation/gitcoinhomepagebg.png';
import gitcoinIcon from '@/assets/donation/gitcoinicon.png';
import { checkoutToken, utilLogin } from '@/utils/checkLogin';
import { apiOrgGotcoinOrg } from '@/apis/donation';
import { useAppSetting } from '@/store/appSetting';

export interface ClaimItem {
  avatar: string;
  claimedCount: number;
  contractAddress: string;
  createdAt: string;
  desc: string;
  id: number;
  name: string;
  org: {
    adminAddressList: string[];
    avatar: string;
    contractAddress: string;
    contractState: number;
    creatorId: number;
    desc: string;
    discord: string;
    id: string;
    name: string;
    twitter: string;
  };
  sbtPic: string;
  userSbtPic: string;
  receiverAddress: string;
  senderAddress: string;
  state: number;
  tokenId: number;
  type: string;
  updatedAt: string;
}

const Gitcoin = () => {
  const { setAuth } = useAppSetting();

  const [showModal, setShowModal] = useState(false);
  const [activeItem, setActiveItem] = useState<ClaimItem>();
  const pageRef = useRef(true);
  const [info, setInfo] = useState({ claimedCount: 0 });

  const handleOpenModal = async () => {
    const data = await checkoutToken();
    if (!data || !localStorage.getItem('address')) {
      const res = await utilLogin();
      if (res) {
        setAuth(res.auth);
        setShowModal(true);
      }
    } else {
      setShowModal(true);
    }
  };

  const handleGetSbtList = async () => {
    const res = await apiGetSbtList({
      currentPage: 1,
      pageSize: 100,
      state: '0'
    });
    setActiveItem(res[0]);
  };

  const handleGetOrg = async () => {
    const orgData: any = await apiOrgGotcoinOrg();
    if (orgData) {
      setInfo(orgData);
    }
  };

  useEffect(() => {
    if (pageRef.current) {
      pageRef.current = false;
      handleGetOrg();
      setTimeout(() => {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }, 500);
    }
  }, []);

  return (
    <div className="profile flex w-[100vw] flex-col items-center ">
      <div className="w-[100%]">
        <Card
          className="mx-4 my-[30px] w-auto bg-[white] pb-4"
          style={{
            filter: 'drop-shadow(0px 2px 30px #eff1f1)'
          }}
        >
          <div className="flex justify-between">
            <div className="min-h-[400px] flex-1">
              <div className="ml-[112px] mt-[74px]">
                <div className="flex items-center">
                  <img
                    src={gitcoinIcon}
                    className="h-[62px] w-[152px]"
                    alt=""
                  />
                  <Typography className="ml-[10px] flex h-[26px] items-center justify-center rounded-[6px] bg-[#F3F6F4] py-[3px] px-[19px]">
                    {info.claimedCount} Vitae Claimed
                  </Typography>
                </div>
                <Typography
                  variant="title"
                  className="mt-[18px] text-[45px] leading-[45px] text-[#B29CC7]"
                >
                  PROOF OF DONATION
                </Typography>
                <Typography className="mt-[30px]">
                  All Gitcoin donators can{' '}
                  <Typography tag="span" className="underline decoration-solid">
                    free mint an non-transferable NFT
                  </Typography>{' '}
                  to memorize their contribution permanetly.
                </Typography>
                <Button
                  className="mt-[69px] w-[140px] font-[600]"
                  onClick={handleOpenModal}
                >
                  Claim
                  <svg
                    width="13"
                    height="12"
                    viewBox="0 0 13 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="ml-[10px] h-[12px] w-[12px]"
                  >
                    <path
                      d="M6.99497 11.195L11.995 6.19497C12.2683 5.92161 12.2683 5.47839 11.995 5.20502L6.99497 0.205025C6.7216 -0.0683418 6.27839 -0.0683417 6.00502 0.205025C5.73166 0.478392 5.73166 0.921608 6.00502 1.19497L9.81005 5L0.7 5C0.313401 5 0 5.3134 0 5.7C0 6.0866 0.313401 6.4 0.7 6.4L9.81005 6.4L6.00502 10.205C5.73166 10.4784 5.73166 10.9216 6.00502 11.195C6.27839 11.4683 6.72161 11.4683 6.99497 11.195Z"
                      fill="#4E4E4E"
                    />
                  </svg>
                </Button>
              </div>
            </div>
            <div className="mr-[22px] mt-[90px] flex h-[290px] w-[30px] items-center justify-center sm:w-[572px]">
              <img
                className="invisible h-[348px] w-[30px] sm:visible sm:w-[309px]"
                src={gitcoinbg}
                alt=""
              />
            </div>
          </div>
          <div className="mt-[96px] mb-[133px] flex flex-wrap items-center justify-center px-[108px] sm:flex-nowrap">
            <div className="my-3 flex min-h-[70px] w-80 items-center justify-center rounded-[19px] border border-[#554e59] bg-white px-2">
              <svg
                width={33}
                height={33}
                viewBox="0 0 33 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="relative mr-[14px] h-[33px] w-[33px]"
                preserveAspectRatio="none"
              >
                <path
                  d="M27.5 22V11.6875C27.5 10.549 26.6186 9.625 25.465 9.625C24.75 9.625 23.375 10.0375 23.375 11.6875V7.5625C23.375 6.424 22.4936 5.5 21.34 5.5C20.6429 5.5 19.25 5.9125 19.25 7.5625V4.8125C19.25 3.674 18.3686 2.75 17.215 2.75C16.06 2.75 15.125 3.674 15.125 4.8125V7.5625C15.125 5.9125 13.7596 5.5 13.0625 5.5C11.9075 5.5 11 6.45012 11 7.59V19.25M15.125 7.5625V15.125M19.25 7.5625V15.125M23.375 7.5625V15.125"
                  stroke="#534C57"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M27.4998 22C27.4998 27.5 23.1905 30.25 17.8748 30.25C12.559 30.25 10.7303 28.875 6.60529 22L4.44517 18.4182C3.70817 17.2247 4.29804 15.6764 5.65654 15.2364C6.10075 15.0913 6.57885 15.0863 7.02601 15.2221C7.47316 15.3578 7.86776 15.6278 8.15629 15.9954L10.9998 19.2954"
                  stroke="#534C57"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <p className="text-sm">
                <span className="text-start text-sm font-bold text-[#554f59]">
                  Claim Gitcoin NFT
                </span>
                <br />
                <span className="text-start text-sm text-[#787878]">
                  Proof of Donation
                </span>
              </p>
            </div>
            <svg
              className="mx-[42px] origin-center rotate-90 sm:rotate-0"
              width={13}
              height={12}
              viewBox="0 0 13 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
            >
              <path
                d="M6.99497 11.195L11.995 6.19497C12.2683 5.92161 12.2683 5.47839 11.995 5.20502L6.99497 0.205025C6.7216 -0.0683418 6.27839 -0.0683417 6.00502 0.205025C5.73166 0.478392 5.73166 0.921608 6.00502 1.19497L9.81005 5L0.7 5C0.313401 5 0 5.3134 0 5.7C0 6.0866 0.313401 6.4 0.7 6.4L9.81005 6.4L6.00502 10.205C5.73166 10.4784 5.73166 10.9216 6.00502 11.195C6.27839 11.4683 6.72161 11.4683 6.99497 11.195Z"
                fill="#564F5A"
              />
            </svg>
            <div className="my-3 flex min-h-[70px] w-80 items-center justify-center rounded-[19px] border border-[#554e59] bg-white px-2">
              <svg
                width={30}
                height={30}
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="relative mr-[14px] h-[33px] w-[33px]"
                preserveAspectRatio="none"
              >
                <path
                  d="M12.1436 15C13.5823 15 14.6436 13.9388 14.6436 12.5C14.6436 11.0612 13.5823 10 12.1436 10C10.7048 10 9.64355 11.0612 9.64355 12.5C9.64355 13.9388 10.7036 15 12.1436 15Z"
                  fill="#534C57"
                />
                <path
                  d="M25 5H5C3.62125 5 2.5 6.05125 2.5 7.34375V22.6562C2.5 23.9488 3.62125 25 5 25H25C26.3788 25 27.5 23.9488 27.5 22.6562V7.34375C27.5 6.05125 26.3788 5 25 5ZM25 22.5L5 22.4863V7.5L25 7.51375V22.5Z"
                  fill="#534C57"
                />
                <path
                  d="M17.5 11.25H22.5V13.75H17.5V11.25ZM18.75 16.25H22.5V18.75H18.75V16.25ZM16.7875 19.42C16.7875 17.7025 14.6925 15.9375 12.1438 15.9375C9.595 15.9375 7.5 17.7025 7.5 19.42V20H16.7875V19.42Z"
                  fill="#534C57"
                />
              </svg>
              <p className="text-sm">
                <span className="text-start text-sm font-bold text-[#554f59]">
                  Build on-chain Profile
                </span>
                <br />
                <span className="text-start text-sm text-[#787878]">
                  Link, ID, Activity
                </span>
              </p>
            </div>
            <svg
              className="mx-[42px] rotate-90 sm:rotate-0"
              width={13}
              height={12}
              viewBox="0 0 13 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
            >
              <path
                d="M6.99497 11.195L11.995 6.19497C12.2683 5.92161 12.2683 5.47839 11.995 5.20502L6.99497 0.205025C6.7216 -0.0683418 6.27839 -0.0683417 6.00502 0.205025C5.73166 0.478392 5.73166 0.921608 6.00502 1.19497L9.81005 5L0.7 5C0.313401 5 0 5.3134 0 5.7C0 6.0866 0.313401 6.4 0.7 6.4L9.81005 6.4L6.00502 10.205C5.73166 10.4784 5.73166 10.9216 6.00502 11.195C6.27839 11.4683 6.72161 11.4683 6.99497 11.195Z"
                fill="#564F5A"
              />
            </svg>
            <div className="my-3 flex min-h-[70px] w-80 items-center justify-center rounded-[19px] border border-[#554e59] bg-white px-2">
              <svg
                width={33}
                height={33}
                viewBox="0 0 33 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="relative mr-[14px] h-[33px] w-[33px]"
                preserveAspectRatio="none"
              >
                <path
                  d="M7.4252 3.30005C6.76878 3.30005 6.13926 3.56081 5.67511 4.02496C5.21095 4.48911 4.9502 5.11864 4.9502 5.77505V27.225C4.9502 27.8815 5.21095 28.511 5.67511 28.9751C6.13926 29.4393 6.76878 29.7 7.4252 29.7H18.9752C19.6316 29.7 20.2611 29.4393 20.7253 28.9751C21.1894 28.511 21.4502 27.8815 21.4502 27.225V24.75C21.4502 24.5312 21.3633 24.3214 21.2086 24.1667C21.0538 24.012 20.844 23.925 20.6252 23.925C19.9437 23.925 19.5081 23.7567 19.2128 23.5356C18.9108 23.3096 18.6815 22.9713 18.5132 22.5077C18.1601 21.5375 18.1502 20.2521 18.1502 18.975C18.1502 18.8665 18.1287 18.7591 18.0871 18.6588C18.0455 18.5586 17.9845 18.4676 17.9076 18.3909L17.4357 17.9174L15.4343 15.9159C14.6637 15.1454 14.4377 14.6289 14.3948 14.3402C14.3618 14.1092 14.4311 13.9541 14.5961 13.7957C14.9492 13.4574 15.2016 13.2281 15.4871 13.1588C15.657 13.1159 16.0448 13.0862 16.7411 13.7825L21.6911 18.7325C21.8458 18.8874 22.0557 18.9745 22.2746 18.9747C22.383 18.9748 22.4904 18.9535 22.5905 18.9121C22.6907 18.8707 22.7818 18.8099 22.8585 18.7333C22.9352 18.6567 22.996 18.5658 23.0376 18.4657C23.0791 18.3655 23.1006 18.2582 23.1007 18.1498C23.1007 18.0414 23.0795 17.9341 23.038 17.8339C22.9966 17.7337 22.9359 17.6427 22.8593 17.5659L21.4502 16.1585V11.0666L25.6742 15.2906C25.9043 15.5204 26.0868 15.7933 26.2114 16.0937C26.336 16.3941 26.4001 16.7161 26.4002 17.0412V28.875C26.4002 29.0939 26.4871 29.3037 26.6418 29.4584C26.7965 29.6131 27.0064 29.7 27.2252 29.7C27.444 29.7 27.6538 29.6131 27.8086 29.4584C27.9633 29.3037 28.0502 29.0939 28.0502 28.875V17.0412C28.05 15.9477 27.6155 14.899 26.8424 14.1257L21.4502 8.7335V5.77505C21.4502 5.11864 21.1894 4.48911 20.7253 4.02496C20.2611 3.56081 19.6316 3.30005 18.9752 3.30005H7.4252ZM19.8002 9.07505V14.5085L17.9093 12.6159C16.9539 11.6622 16.0052 11.3339 15.096 11.555C14.9174 11.5991 14.7443 11.6627 14.5796 11.7447C13.842 11.5311 13.0649 11.4919 12.3096 11.6303C11.5543 11.7686 10.8415 12.0808 10.2276 12.542C9.61363 13.0033 9.11539 13.601 8.77221 14.2879C8.42904 14.9748 8.25032 15.7322 8.2502 16.5C8.25013 17.457 8.52742 18.3934 9.04851 19.196C9.56961 19.9985 10.3122 20.6329 11.1863 21.0222C12.0604 21.4115 13.0287 21.5391 13.9738 21.3896C14.919 21.24 15.8005 20.8197 16.5117 20.1795C16.5398 21.1332 16.6355 22.176 16.9622 23.072C17.2064 23.7435 17.5958 24.3854 18.2228 24.854L18.2327 24.8639C17.7303 25.0219 17.2913 25.3361 16.9797 25.7607C16.6682 26.1854 16.5002 26.6984 16.5002 27.225V28.05H9.9002V27.225C9.9002 26.5686 9.63944 25.9391 9.17528 25.475C8.71113 25.0108 8.08161 24.75 7.4252 24.75H6.6002V8.25005H7.4252C8.08161 8.25005 8.71113 7.98929 9.17528 7.52514C9.63944 7.06099 9.9002 6.43146 9.9002 5.77505V4.95005H16.5002V5.77505C16.5002 6.43146 16.761 7.06099 17.2251 7.52514C17.6893 7.98929 18.3188 8.25005 18.9752 8.25005H19.8002V9.07505ZM19.8002 27.225V27.2399C19.7963 27.4561 19.7077 27.6622 19.5534 27.8137C19.3991 27.9652 19.1914 28.0501 18.9752 28.05H18.1502V27.225C18.1502 27.0062 18.2371 26.7964 18.3918 26.6417C18.5465 26.487 18.7564 26.4 18.9752 26.4H19.8002V27.225ZM9.9002 16.5C9.90021 15.6608 10.22 14.8531 10.7944 14.2413C11.3688 13.6295 12.1547 13.2595 12.9923 13.2066C12.7877 13.5861 12.6837 14.0481 12.7629 14.5811C12.8801 15.3764 13.3866 16.203 14.2661 17.0825L15.7626 18.579C15.333 19.1085 14.75 19.4918 14.0936 19.6764C13.4372 19.861 12.7398 19.8378 12.0972 19.6099C11.4546 19.382 10.8984 18.9607 10.505 18.4038C10.1115 17.8469 9.90028 17.1819 9.9002 16.5V16.5ZM8.2502 4.95005V5.77505C8.2502 5.99385 8.16328 6.20369 8.00856 6.35841C7.85384 6.51313 7.644 6.60005 7.4252 6.60005H6.6002V5.77505C6.6002 5.55625 6.68711 5.3464 6.84183 5.19169C6.99655 5.03697 7.20639 4.95005 7.4252 4.95005H8.2502ZM6.6002 26.4H7.4252C7.644 26.4 7.85384 26.487 8.00856 26.6417C8.16328 26.7964 8.2502 27.0062 8.2502 27.225V28.05H7.4252C7.20639 28.05 6.99655 27.9631 6.84183 27.8084C6.68711 27.6537 6.6002 27.4439 6.6002 27.225V26.4ZM19.8002 6.60005H18.9752C18.7564 6.60005 18.5465 6.51313 18.3918 6.35841C18.2371 6.20369 18.1502 5.99385 18.1502 5.77505V4.95005H18.9752C19.194 4.95005 19.4038 5.03697 19.5586 5.19169C19.7133 5.3464 19.8002 5.55625 19.8002 5.77505V6.60005Z"
                  fill="#534C57"
                />
              </svg>
              <p className="text-sm">
                <span className="text-start text-sm font-bold text-[#4e4e4e]">
                  Token Airdrop
                </span>
                <br />
                <span className="text-start text-sm text-[#787878]">
                  Coming soon
                </span>
              </p>
            </div>
          </div>
        </Card>
        {showModal ? (
          <ClaimModal
            item={activeItem}
            onClose={() => {
              setShowModal(false);
            }}
            onConfirm={() => {
              handleGetSbtList();
              // onConfirm();
              setShowModal(false);
            }}
            onCancel={() => {
              setShowModal(false);
            }}
            onGetSbt={handleGetSbtList}
          ></ClaimModal>
        ) : null}
      </div>
    </div>
  );
};

export default Gitcoin;
